import React, { FC, ReactNode } from "react";
import Card from "./Card";
import Box from "./Box";
import Button from "./Button";
import { ArrowBack, Close, Replay, Search } from "@mui/icons-material";
import Title from "./Title";
import { useTheme } from "styled-components";
import { useHistory } from "react-router-dom";
import Form from "./Form";
import Tooltip from "./Tooltip";
import { useTranslation } from "_metronic/i18n/language";

interface TableToolBarProps {
  titleTable?: string;
  placeholderSearch?: string;
  search?: any;
  setSearch?: any;
  onRefresh: any;
  router?: string;
  additionalButtonsContainer?: ReactNode;
}

const TableToolBar: FC<TableToolBarProps> = ({
  titleTable,
  placeholderSearch,
  search,
  setSearch,
  onRefresh,
  router,
  additionalButtonsContainer,
}) => {
  const theme = useTheme();
  const history = useHistory();
  const translate = useTranslation();

  return (
    <Card
      style={{
        width: "100%",
        margin: "0",
        padding: "20px",
        boxShadow: "none",
        borderRadius: "0",
        border: "none",
        overflow: "visible",
      }}
    >
      {(titleTable || router || onRefresh) && (
        <Box
          style={{
            width: "100%",
            margin: "0",
            boxShadow: "none",
            borderRadius: "0",
            border: "none",
            justifyContent: "start",
            position: "relative",
            padding: "0",
            paddingBottom: "1em",
            gap: "20px",
          }}
        >
          {router && (
            <Button
              style={{
                color: theme.text,
                padding: ".5em .6em",
                borderRadius: "50%",
                margin: "0",
              }}
              styleHover={{
                backgroundColor: "#43434313",
              }}
              onClick={() => {
                history.push(router);
              }}
            >
              <ArrowBack />
            </Button>
          )}
          <Title
            style={{
              fontSize: "1.6em",
              fontWeight: "600",
            }}
          >
            {titleTable ? titleTable : ""}
          </Title>
          {onRefresh && (
            <Button
              style={{
                color: theme.text,
                padding: ".5em .6em",
                borderRadius: "50%",
                margin: "0",
                position: "absolute",
                right: "5px",
              }}
              styleHover={{
                backgroundColor: "#43434313",
              }}
              onClick={onRefresh}
            >
              <Replay />
            </Button>
          )}
        </Box>
      )}

      <Box style={{ width: "100%", padding: "0", gap: "20px" }}>
        {additionalButtonsContainer && additionalButtonsContainer}
        <Form
          style={{
            backgroundColor: theme.background,
            width: "100%",
            display: "flex",
            flexDirection: "row",
            boxShadow: "0px 0px 15px #00000015",
            borderRadius: "5px",
          }}
        >
          <Form.Label
            style={{
              fontSize: "2em",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "0 .5em",
            }}
          >
            <Search
              style={{
                color: theme.text,
              }}
            />
          </Form.Label>
          <Form.Input
            style={{
              border: "none",
              backgroundColor: "transparent",
              flexGrow: "1",
            }}
            placeholder={placeholderSearch ? placeholderSearch : ""}
            value={search}
            onInput={e => setSearch((e.target as HTMLInputElement).value)}
          />
          {search !== "" && (
            <Tooltip
              title={translate("screens.capsule.placeholders.clearSearch")}
              position="bottom"
              style={{ padding: "0 .5em" }}
              onClick={() => setSearch("")}
            >
              <Close
                style={{
                  color: theme.text,
                }}
              />
            </Tooltip>
          )}
        </Form>
      </Box>
    </Card>
  );
};

export default TableToolBar;
